export default __webpack_public_path__ + "static/media/BrownMediumRegular.6df329d5.ttf";